export const globalStyles = {
  flex1: { display: "flex", flex: 1 },
  colFlex1: { display: "flex", flexDirection: "column", flex: 1 },
  col: {
    display: "flex",
    flexDirection: "column",
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  colCenter: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  rowCenter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },

  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  fullFlexLoader: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
  },

  absoluteCenter: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
  },

  blurView: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  fullFlexImage: {
    width: "100%",
    height: "100%",
  },

  graphDot: {
    width: "10px",
    height: "10px",
    borderRadius: "6px",
    marginTop: "4px",
  },

  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: "white",
    borderRadius: 4,
  },
};
